import RequesterV1 from "@/components/api/v1/requester.js";

const rootPath = "agro_exporter/finances/harvested_batch_outcomes";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/show_process/${agro_exporter_process_id}`
    );
  },

  fetchOrgInvoice(agro_exporter_id, org_invoice_id) {
    return RequesterV1.get(
      `${rootPath}/${agro_exporter_id}/show_org_invoice/${org_invoice_id}`
    );
  },
};
